import { useCollapse } from 'react-collapsed';
import { CaretDown, CaretUp } from '@phosphor-icons/react';
import styles from './RelatedQuestions.module.scss';
import { QuestionItem } from './components/QuestionItem';
import { RelatedQuestion } from 'src/types';
import { SVG_SIZE_M } from 'src/constants';

interface RelatedQuestionsProps {
  data?: RelatedQuestion[];
  defaultExpanded?: boolean;
  title?: string;
}

export const RelatedQuestions = ({
  data,
  defaultExpanded,
  title = 'Related questions',
}: RelatedQuestionsProps) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
    defaultExpanded,
  });

  if (!data) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <button {...getToggleProps()} className={styles.collapseButton}>
          {isExpanded ? (
            <CaretDown size={SVG_SIZE_M} />
          ) : (
            <CaretUp size={SVG_SIZE_M} />
          )}

          <span>{title}</span>
        </button>
      </div>

      <div {...getCollapseProps()}>
        <div className={styles.collapseItemsBlock}>
          {data.slice(0, 3).map(({ question }, index) => (
            <QuestionItem key={index} question={question} />
          ))}
        </div>
      </div>
    </div>
  );
};
